import React from "react"

function IconMicrophonesSlash({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="microphones-slash"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-microphones-slash"
      {...props}
    >
      <path
        d="M2.368 10.581c.361 0 .654.293.654.655a5.837 5.837 0 0 0 9.99 4.104l.953.895-.118.12a7.126 7.126 0 0 1-4.333 1.998v2.709a.655.655 0 0 1-1.3.106l-.01-.106v-2.71a7.147 7.147 0 0 1-6.49-7.116c0-.362.292-.655.654-.655zm19.622.637c.362 0 .655.293.655.654a5.343 5.343 0 0 1-3.07 4.837l-1.054-.99a4.035 4.035 0 0 0 2.815-3.847c0-.361.293-.654.654-.654zM5.236 8.05l1.309 1.227V11.4a2.345 2.345 0 0 0 4.017 1.645l.955.895a3.655 3.655 0 0 1-6.28-2.54l-.001-3.35zM17.324 5.57a2.64 2.64 0 0 1 2.64 2.64v3.78a2.64 2.64 0 0 1-2.607 2.64l-2.72-2.552c.022-.156.039-.314.049-.473l-.001-3.396a2.64 2.64 0 0 1 2.64-2.64zm0 1.309a1.33 1.33 0 0 0-1.323 1.194l-.007.136v2.903c.008.04.012.081.012.124 0 .136-.004.27-.011.405l-.001.35a1.33 1.33 0 0 0 2.654.136l.007-.136V8.209a1.33 1.33 0 0 0-1.33-1.33zm-8.433-4.37a3.655 3.655 0 0 1 3.654 3.655l-.001 3.952-1.308-1.226V6.164A2.345 2.345 0 0 0 6.94 4.862l-.964-.902a3.649 3.649 0 0 1 2.916-1.45z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M2.795 3.37a.655.655 0 0 1 .832-.102l.093.073 17.455 16.363a.655.655 0 0 1-.802 1.028l-.093-.073L2.825 4.296a.655.655 0 0 1-.03-.925z"
        fill={color2 || color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconMicrophonesSlash
